import { TextField } from "@mui/material"
import { useState } from "react"
import FormItem from "../ui/FormItem"
import Modal from "../ui/Modal"

const SetClassName = ({ setName, ...props }) => {
  const [cName, setCName] = useState("")
  return (
    <Modal
      {...props}
      actionText="Set"
      action={() => {
        setName(cName)
        props.close()
      }}
    >
      <FormItem label="Class name">
        <TextField
          autoFocus
          value={cName}
          onChange={(e) => setCName(e.target.value)}
        />
      </FormItem>
    </Modal>
  )
}

export default SetClassName
